const DaysTime = 86400

const dayjs = require('dayjs')

export default {
  /**
   * 相隔天数
   * @param {Date} start 开始日期
   * @param {Date} end 结束日期
   * @returns 
   */
  DateDiff (start, end) {
    const startDate = dayjs(start)
    const endDate = dayjs(end)

    return endDate.diff(startDate, 'day')
  },
  Today () {
    const today = new Date()
    return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
  },
  TodayTime () {
    const today = new Date()
    const todaytime = new Date(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`).getTime()
    return todaytime
  },
  /**
   * 转换为日期格式
   * @param {Date} val 
   */
  ConvertDate (val) {
    var date = new Date(val);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    return Y + M + D;
  },
  ConvertDateStr (val) {
    const valDate = new Date(val)
    return `${valDate.getFullYear()}-${valDate.getMonth() + 1}-${valDate.getDate()}`
  },
  /**
   * 禁用日期
   * @param {*} date1 日期控件上的日子
   * @param {*} date2 小于这个日期就禁用日子
   */
  DisabledDate (date1, date2) {
    return this.DateDiff(date1, date2) > 0;
  },
  /**
   * 最大的那个日期
   * @param {*} arrs 
   */
  Max (arrs) {
    arrs = arrs || []
    if (arrs.length == 0) {
      return ""
    }

    const sortArrs = arrs.sort()

    return sortArrs[sortArrs.length - 1]
  },
  /**
   * 给日期添加天数
   * @param {Date} date 日期
   * @param {Number} Days 添加的日数
   * @returns 
   */
  AddDays (date, Days) {
    Days = Days || 0

    return this.ConvertDate(new Date(date).getTime() + Days * DaysTime * 1000);
  },
  /**
   * Date Picker 禁用日期
   * @param {*} date 
   * @returns 
   */
  DatePickerDisabledDate (date, date1, date2) {
    var start = new Date(date1);
    var end = new Date(date2);
    return !(date >= start && date <= end)
  }
}
